import React, { FC } from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { Card, Button, Typography, SurfaceColor } from "@carrotfertility/carotene-core"

type BenefitEnrollmentModuleProps = {
  onClickEnroll: () => void
  color?: SurfaceColor
}

const BenefitEnrollmentModule: FC<BenefitEnrollmentModuleProps> = ({ onClickEnroll, color = "green" }) => {
  const { formatMessage } = useIntl()
  return (
    <Card
      variant="secondary"
      color={color}
      title={formatMessage({ defaultMessage: "To access your funds, tell us about your insurance" })}
      primaryAction={
        <Button variant="outlined" color="secondary" onClick={onClickEnroll}>
          <FormattedMessage defaultMessage="Share plan info" />
        </Button>
      }
      id="home-sidebar-benefit-enrollment-module"
    >
      <Typography>
        <FormattedMessage defaultMessage="Your insurance coverage affects how Carrot funds are taxed and whether a deductible applies." />
      </Typography>
    </Card>
  )
}

export { BenefitEnrollmentModule }
